import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../utils/axios";
import EntityManagement from "../formTemplates/EntityManagement";
import EntityTable from "../templateComponents/EntityTable";

const BeaconMainConfiguration = () => {
  const [formData, setFormData] = useState({
    bec_name: "",
    bldg_id: "",
    bec_floor_id: "",
    bec_type_id: "",
    bex_pt_map_X: "",
    bex_pt_map_Y: "",
  });

  const [configs, setConfigs] = useState([]);
  const [isTableModalOpen, setIsTableModalOpen] = useState(false);
  const firstFormFieldRef = useRef(null);

  const endpoints = {
    viewAll: "/view_beacon_config/v1.1",
    register: "/registration_beacon_config/v1.1",
  };

  const loadConfigs = async () => {
    try {
      const response = await axiosInstance.post(endpoints.viewAll, {
        view_type: "view all",
      });

      if (response.data.Status === "Success") {
        setConfigs(response.data.Data || []);
      } else {
        console.error("API error:", response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching beacon configurations:", error);
    }
  };

  useEffect(() => {
    loadConfigs();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!formData.bec_name || !formData.bldg_id || !formData.bec_floor_id || !formData.bec_type_id || !formData.bex_pt_map_X || !formData.bex_pt_map_Y) {
      alert("Please fill in all required fields.");
      return;
    }

    const payload = {
      bec_name: formData.bec_name.trim(),
      bldg_id: parseInt(formData.bldg_id, 10),
      bec_floor_id: parseInt(formData.bec_floor_id, 10),
      bec_type_id: parseInt(formData.bec_type_id, 10),
      bex_pt_map_X: parseInt(formData.bex_pt_map_X, 10),
      bex_pt_map_Y: parseInt(formData.bex_pt_map_Y, 10),
    };

    try {
      const response = await axiosInstance.post(endpoints.register, payload);
      if (response.data.Status === "Success") {
        loadConfigs();
        resetForm();
      } else {
        console.error("Registration failed:", response.data.Message);
      }
    } catch (error) {
      console.error("Registration error:", error);
    }
  };

  const resetForm = () => {
    setFormData({
      bec_name: "",
      bldg_id: "",
      bec_floor_id: "",
      bec_type_id: "",
      bex_pt_map_X: "",
      bex_pt_map_Y: "",
    });
  };

  const handleViewTableClick = () => {
    setIsTableModalOpen(true);
  };

  const formFields = [
    { name: "bec_name", label: "Beacon Name", type: "text", required: true },
    { name: "bldg_id", label: "Building ID", type: "text", required: true },
    { name: "bec_floor_id", label: "Floor ID", type: "text", required: true },
    { name: "bec_type_id", label: "Beacon Type ID", type: "text", required: true },
    { name: "bex_pt_map_X", label: "Map X Coord", type: "text", required: true },
    { name: "bex_pt_map_Y", label: "Map Y Coord", type: "text", required: true },
  ];

  const columns = [
    { name: "bec_config_id", label: "Config ID" },
    { name: "bec_id", label: "Beacon ID" },
    { name: "bec_unique_id", label: "Unique ID" },
    { name: "bec_instance_key", label: "Instance Key" },
    { name: "bec_namespace_key", label: "Namespace Key" },
  ];

  return (
    <div className="beacon-configuration">
      <EntityManagement
        entityName="Beacon Configuration"
        formFields={formFields}
        formData={formData}
        setFormData={setFormData}
        handleFormSubmit={handleFormSubmit}
        firstFormFieldRef={firstFormFieldRef}
        handleViewTableClick={handleViewTableClick}
      />

      {isTableModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <button onClick={() => setIsTableModalOpen(false)}>Close</button>
            <EntityTable
              data={configs}
              columns={columns}
              keyField="bec_config_id"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BeaconMainConfiguration;
